import axios from 'axios'

export default {
    methods: {
        async getCirculationProfileSchemas(filter){
            const {data} = await axios.post("circulationprofileschema/get", filter);
            return data;
        },
        async getCirculationProfileSchemasDetailed(filter){
            const {data} = await axios.post("circulationprofileschema/getdetailed", filter);
            return data;
        },
        async getExternalSigners(filter){
            const {data} = await axios.post("externalsigner/getforexport", filter);
            return data;
        },
        async getUsers(filter){
            const {data} = await axios.post("user/get", filter);
            return data;
        },
        async getDepartments(filter){
            const {data} = await axios.post("department/get", filter);
            return data;
        },
        async getOnlineViewPermission(){
            const {data} = await axios.get("account/GetOnlineViewPermission");
            return data;
        },
        async getFilters(filter){
            const {data} = await axios.post("incomingFilter/get", filter);
            return data;
        },
        async getIncomingChannel(filter){
            const {data} = await axios.post("incomingChannel/get", filter);
            return data;
        },
        async getTitles(filter){
            const {data} = await axios.post("title/get", filter);
            return data;
        },
        async getCategories(filter){
            const {data} = await axios.post("category/get", filter);
            return data;
        },
        async getTargetSystems(){
            const {data} = await axios.post("targetsystem/get", {OrderBy: 'Name', predicate: "IsSingleUse=false && IsActive= true" });
            return data;
        },
        async getOzne(filter){
            const {data} = await axios.post("ozne/get", filter);
            return data;
        },
        async getAuthorizationDefinitions(){
            const {data} = await axios.get("user/getAuthorizationDefinitions");
            return data;
        },
        async getRemProviders(){
            const {data} = await axios.post('/remprovider/get');
            return data;
        },
        async getUetsProviders(){
            const {data} = await axios.post('/uetsprovider/get');
            return data;
        },
        async searchDetsisByName(name){
            let headers = new Headers();
            headers.append('Content-Type', 'application/json');
            headers.append('Accept', 'application/json');
            headers.append('Access-Control-Allow-Origin', '*');
            headers.append('GET', 'POST', 'OPTIONS');

            return axios({
                method: 'get',
                url: window.settings.detsisApiUrl.replace(/([/]*)$/g, '') + '/detsis/filterByName',
                params: {name:name},
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Headers":"*",
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS"
                }
            });
        },
        async getDetsisByNumber(number){
            const {data} = await axios.get(window.settings.detsisApiUrl.replace(/([/]*)$/g, '') + '/detsis/get-by-number?detsisNo=' + number);
            return data;
        },
        async getDetsisContactInfo(number){
            return axios({
                method: 'get',
                url: window.settings.detsisApiUrl.replace(/([/]*)$/g, '') + '/detsis/getUnitContactInfo',
                params: {detsisNo:number},
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Headers":"*",
                    // 'Content-Type': 'application/json',
                    // 'Accept': 'application/json',
                    "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS"
                }
            });
        },
        async getDetsisUnitRem(number){
            return axios({
                method: 'get',
                url: window.settings.detsisApiUrl.replace(/([/]*)$/g, '') + '/detsis/getUnitRemInfo',
                params: {detsisNo:number},
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Headers":"*",
                    // 'Content-Type': 'application/json',
                    // 'Accept': 'application/json',
                    "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS"
                }
            });
        },        
        async getRemProviderStats(provider){
            const {data} = await axios({
                method: 'get',
                url: '/remprovider/GetRemBoxStats',
                params: { providerId:provider},
            });
            return data;
        }
    }
}
